import { render, staticRenderFns } from "./EmployerCardsList.vue?vue&type=template&id=0a216690&scoped=true"
import script from "./EmployerCardsList.vue?vue&type=script&lang=ts"
export * from "./EmployerCardsList.vue?vue&type=script&lang=ts"
import style0 from "./EmployerCardsList.vue?vue&type=style&index=0&id=0a216690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a216690",
  null
  
)

export default component.exports